var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasNetwork
    ? _c("div", { staticClass: "bn-causal-network" }, [
        _c(
          "div",
          { staticClass: "bn-causal-network__legend" },
          _vm._l(_vm.legendItems, function (item) {
            return _c(
              "span",
              { key: item.type, staticClass: "bn-causal-network__legend-item" },
              [
                _c("span", {
                  staticClass: "bn-causal-network__swatch",
                  style: { backgroundColor: item.color },
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(" " + _vm._s(item.label) + " "),
              ]
            )
          }),
          0
        ),
        _c("div", { staticClass: "bn-causal-network__wrapper" }, [
          _c("div", {
            ref: "container",
            staticClass: "bn-causal-network__canvas",
            style: { height: _vm.height + "px" },
          }),
          _vm.ready
            ? _c("div", { staticClass: "bn-causal-network__zoom" }, [
                _c(
                  "label",
                  {
                    staticClass: "bn-causal-network__zoom-label",
                    attrs: { for: "bn-causal-zoom-range" },
                  },
                  [_vm._v("Zoom")]
                ),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.number",
                      value: _vm.zoom,
                      expression: "zoom",
                      modifiers: { number: true },
                    },
                  ],
                  staticClass: "bn-causal-network__zoom-range",
                  attrs: {
                    id: "bn-causal-zoom-range",
                    type: "range",
                    min: _vm.zoomMin,
                    max: _vm.zoomMax,
                    step: "0.05",
                  },
                  domProps: { value: _vm.zoom },
                  on: {
                    input: _vm.applyZoom,
                    __r: function ($event) {
                      _vm.zoom = _vm._n($event.target.value)
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
              ])
            : _vm._e(),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }